// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

export default class MenuHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      menuAvailable: false,
    };
    this.handleMouseEnterOnLink = this.handleMouseEnterOnLink.bind(this);
    this.handleMouseLeaveOnLink = this.handleMouseLeaveOnLink.bind(this);
    this.handleMouseEnterOnMenu = this.handleMouseEnterOnMenu.bind(this);
    this.handleMouseLeaveOnMenu = this.handleMouseLeaveOnMenu.bind(this);
    this.handleMouseLeaveOnList = this.handleMouseLeaveOnList.bind(this);

    this.handleClickOnSubmenuToggle = this.handleClickOnSubmenuToggle.bind(this);
    this.handleClickOnSubmenuBackToggle = this.handleClickOnSubmenuBackToggle.bind(this);

    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.openMobileMenu = this.openMobileMenu.bind(this);
    this.closeMobileMenu = this.closeMobileMenu.bind(this);

    this.resetMobileMenu = this.resetMobileMenu.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);

    this.handleSubmenuScroll = this.handleSubmenuScroll.bind(this);
    //this.closeLangSwitch = this.closeLangSwitch.bind(this);
    //this.toggleLangSwitch = this.toggleLangSwitch.bind(this);

    this.openFulltext = this.openFulltext.bind(this);
    this.closeFulltext = this.closeFulltext.bind(this);
    this.myMoserChangeMotive = this.myMoserChangeMotive.bind(this);
  }

  didMount() {
    const self = this;

    this.menu = this.element;
    this.body = document.querySelector('body');
    this.webOverlay = document.querySelector('.web-overlay');
    this.submenuItem = document.querySelectorAll('.header__menu-item');
    this.submenuMobileTrigger = document.querySelectorAll('.submenu__mobile-trigger');
    this.submenuMobileTriggerBack = document.querySelectorAll('.submenu__mobile-trigger-back');
    this.menuToggle = document.querySelector('.header__menu-toggle');
    this.menuList = document.querySelectorAll('.header__menu-list');
    this.menuLink = document.querySelectorAll('.header__menu-link');
    this.submenuLinkMyMoser = document.querySelectorAll('.submenu__related-pages-link--my-moser');
    this.submenu = document.querySelectorAll('.submenu');
    this.header = document.querySelector('.header');
    this.headerMobile = document.querySelector('.header__mobile');
    this.layout = document.querySelector('.layout');
    this.burger = document.querySelector('.header__menu-burger');
    this.langSwitch = document.querySelectorAll('.lang-switch__handler');
    this.fulltext = document.querySelector('.header__fulltext');
    this.fulltextClose = document.querySelector('.header__fulltext-close');
    this.fulltextTrigger = document.querySelectorAll('.header__fulltext-toggle');
    this.fulltextInput = document.querySelectorAll('.form-fulltext__input');
    this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    this.interval = null;
    this.timeout = null;
    this.xDown = null;
    this.yDown = null;
    this.myMoserMotiveChangeAnimation = false;
    this.myMoserMotiveChangeAnimationTimeout = null;


    if (self) {
      this.submenuMobileTrigger.forEach((item) => {
        item.addEventListener('click', this.handleClickOnSubmenuToggle, { passive: true});
      });
      this.submenuMobileTriggerBack.forEach((item) => {
        item.addEventListener('click', this.handleClickOnSubmenuBackToggle, { passive: true});
      });

      this.submenuItem.forEach((item) => {
        const submenu = item.querySelector('.header__menu-link');
        submenu.addEventListener('mouseenter', this.handleMouseEnterOnLink);
        submenu.addEventListener('mouseleave', this.handleMouseLeaveOnLink);
      });

      this.menuList.forEach((item) => {
        item.addEventListener('mouseleave', this.handleMouseLeaveOnList, { passive: true });
      });

      this.menu.addEventListener('mouseenter', this.handleMouseEnterOnMenu, { passive: true });
      this.menu.addEventListener('mouseleave', this.handleMouseLeaveOnMenu, { passive: true });

      this.menuToggle.addEventListener('click', this.handleMenuClose);
      this.webOverlay.addEventListener('click', this.closeMobileMenu);
      this.burger.addEventListener('click', this.toggleMobileMenu);

      this.fulltextTrigger.forEach((item) => {
        item.addEventListener('click', this.openFulltext);
      });
      this.fulltextClose.addEventListener('click', this.closeFulltext);

      document.addEventListener('touchstart', this.handleTouchStart, false);
      document.addEventListener('touchmove', this.handleTouchMove, false);
      window.addEventListener('resize', this.handleSubmenuScroll);
      /*window.addEventListener('click', this.closeLangSwitch);
      this.langSwitch.forEach((item) => {
        item.addEventListener('click', this.toggleLangSwitch);
      });*/
      this.handleSubmenuScroll();

      this.submenuLinkMyMoser.forEach(function (link) {
        link.addEventListener('mouseover',self.myMoserChangeMotive);
        link.addEventListener('mouseout',self.myMoserChangeMotive);
      });
    }
  }

  handleMouseEnterOnLink(e) {
    const parent = e.target.parentElement.parentElement;
    const submenu = parent.querySelector('.submenu');

    if (submenu && this.viewportWidth >= 1280) {
      this.interval = setInterval(() => {
        if (this.state.menuAvailable) {
          submenu.classList.add('submenu--opened');
          this.body.classList.add('menu--on');
          this.webOverlay.classList.add('menu--active');
        }
      }, 100);
    }

    if (!submenu) {
      this.body.classList.remove('menu--on');
    }
  }

  handleMouseLeaveOnLink(e) {
    const parent = e.target.parentElement.parentElement;
    const submenu = parent.querySelector('.submenu');

    if (submenu && this.viewportWidth >= 1280) {
      submenu.classList.remove('submenu--opened');
      this.webOverlay.classList.remove('menu--active');
      clearInterval(this.interval);
      this.interval = null;
    }
  }
  handleMouseEnterOnMenu() {
    this.timeout = setTimeout(() => {
      this.setState({
        menuAvailable: true,
      });
    }, 200);
  }
  handleMouseLeaveOnMenu() {
    this.setState({
      menuAvailable: false,
    });
    clearTimeout(this.timeout);
    this.timeout = null;
  }
  handleMouseLeaveOnList() {
    this.body.classList.remove('menu--on');
  }

  handleClickOnSubmenuToggle(e) {
    const toggle = e.target;
    const parent = toggle.parentElement.parentElement;
    const submenu = parent.querySelector('.submenu');
    const headerMenu = document.querySelector('.header__menu');
    const headerMenuMobile = document.querySelector('.header__menu--mobile');
    const headerMenuLink = parent.querySelector('.header__menu-link');

    if (headerMenuLink.classList.contains('active')) {
      toggle.classList.remove('active');
      submenu.classList.remove('active');
      headerMenu.classList.remove('submenu--opened');
      headerMenuMobile.classList.remove('submenu--opened');
      headerMenuLink.classList.remove('active');
    } else {
      this.resetMobileMenu();
      toggle.classList.add('active');
      submenu.classList.add('active');
      headerMenu.classList.add('submenu--opened');
      headerMenuMobile.classList.add('submenu--opened');
      headerMenuLink.classList.add('active');
      this.handleSubmenuScroll();
    }
  }

  handleClickOnSubmenuBackToggle(e) {
    const toggleBack = e.target;
    const submenu = toggleBack.parentElement.parentElement;
    submenu.classList.remove('active');
    this.submenuMobileTrigger.forEach((item) => {
      item.classList.remove('active');
    });
    this.menuLink.forEach((item) => {
      item.classList.remove('active');
    });
  }

  resetMobileMenu (e) {
    this.submenuMobileTrigger.forEach((item) => {
      const parent = item.parentElement.parentElement;
      const submenu = parent.querySelector('.submenu');
      const headerMenuLink = parent.querySelector('.header__menu-link');
      const headerMenu = document.querySelector('.header__menu');
      const headerMenuMobile = document.querySelector('.header__menu--mobile');
      item.classList.remove('active');
      if (submenu !== null) submenu.classList.remove('active');
      if (headerMenuLink !== null) headerMenuLink.classList.remove('active');
      if (headerMenu !== null) headerMenu.classList.remove('submenu--opened');
      if (headerMenuMobile !== null) headerMenuMobile.classList.remove('submenu--opened');
    });
  }

  handleMenuClose(e) {
    this.resetMobileMenu(e);
    if (this.submenuClone) {
      this.submenuClone.classList.remove('menu-fade-in');
      // let it slide out first
      this.submenuClone.classList.add('menu-fade-out');
      // then remove
      this.submenuClone.parentNode.removeChild(this.submenuClone);
    }
  }
  toggleMobileMenu() {
    if (this.burger.classList.contains('active')) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  }

  openMobileMenu() {
    this.webOverlay.classList.add('active');
    this.header.classList.add('active');
    this.headerMobile.classList.add('active');
    this.layout.classList.add('active');
    this.burger.classList.add('active');
    document.body.classList.add('mobile-menu-opened');
  }

  closeMobileMenu() {
    this.webOverlay.classList.remove('active');
    this.header.classList.remove('active');
    this.headerMobile.classList.remove('active');
    this.layout.classList.remove('active');
    this.burger.classList.remove('active');
    this.menu.classList.remove('submenu--opened');
    document.body.classList.remove('mobile-menu-opened');
    this.submenu.forEach((item) => {
      item.style.transitionDuration = '0ms';
      item.classList.remove('active');
      setTimeout(() => {
        item.style.removeProperty('transition-duration');
      }, 1);
    });
    this.closeFulltext();
  }

  handleTouchStart(e) {
    const firstTouch = e.touches[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  }

  handleTouchMove(e) {
    if (!this.xDown || !this.yDown) {
      return;
    }
    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;
    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        this.closeMobileMenu();
      }
    }
    this.xDown = null;
  }

  handleSubmenuScroll() {
    let contentHeight = 0;
    let activeWrapper = null;
    let activeSubmenu = null;
    this.submenu.forEach((item) => {
      if (item.classList.contains('active')) {
        activeSubmenu = item;
        activeWrapper = item.querySelector('.submenu__scroll-wrapper');
        for (let i = 0; i < activeWrapper.children.length; i++) {
          contentHeight += activeWrapper.children[i].offsetHeight;
        }
      }
    });
    if (activeWrapper) {
      const wrapperStyle = window.getComputedStyle(activeWrapper, null);
      const wrapperHeight = activeWrapper.offsetHeight - parseFloat(wrapperStyle.paddingBottom);
      if (wrapperHeight > contentHeight) {
        activeSubmenu.classList.remove('submemu--active-scroll');
      } else {
        activeSubmenu.classList.add('submemu--active-scroll');
      }
    }
  }

  /*closeLangSwitch(e) {
    if (!e.target.matches('.lang-switch__handler')) {
      this.langSwitch.forEach((item) => {
        item.parentElement.classList.remove('list-select--open');
      });
    }
  }

  toggleLangSwitch(e) {
    const parent = e.target.parentElement;
    if (parent.classList.contains('list-select--open')) {
      parent.classList.remove('list-select--open');
    } else {
      parent.classList.add('list-select--open');
    }
  }*/

  openFulltext() {
    this.fulltext.classList.add('header__fulltext--opened');
    this.webOverlay.classList.add('fulltext--opened');
    this.fulltextClear = document.querySelector('.form-fulltext__clear-button');
    // clear off fulltext field. This is because some value can be added using Fulltext search in FAQ section
    if (this.fulltextClear) this.fulltextClear.click();
    document.body.classList.add('fulltext--opened');
    if (this.fulltextInput){
      this.fulltextInput[0].focus();
    }
  }

  closeFulltext() {
    this.fulltext.classList.remove('header__fulltext--opened');
    this.webOverlay.classList.remove('fulltext--opened');
    document.body.classList.remove('fulltext--opened');

    //const fa = document.querySelector('.fulltext-autocomplete');
    //console.log(fa);
    //if(fa){fa.classList.classList.add('hidden')};
  }

  myMoserChangeMotive(e) {
    const self = this;
    if (e.type === 'mouseover') {
      this.myMoserMotiveChangeAnimation = true;
      clearTimeout(this.myMoserMotiveChangeAnimationTimeout)
      this.element.querySelectorAll('.submenu__banner-motive--my-moser').forEach(function (motive) {
        motive.classList.add('submenu__banner-motive--my-moser-hidden');
      });
      this.element.querySelector('.submenu__banner-motive--my-moser-'+e.target.dataset.index).classList.remove('submenu__banner-motive--my-moser-hidden');
    } else if (e.type === 'mouseout') {
      this.myMoserMotiveChangeAnimation = false;
      this.myMoserMotiveChangeAnimationTimeout = window.setTimeout(function() {
        if (!self.myMoserMotiveChangeAnimation) {
          self.element.querySelectorAll('.submenu__banner-motive--my-moser').forEach(function (motive) {
              motive.classList.add('submenu__banner-motive--my-moser-hidden');
          });
          self.element.querySelector('.submenu__banner-motive--my-moser-1').classList.remove('submenu__banner-motive--my-moser-hidden');
        }
      },1000);
    }
  }

  update() {
    const { menuAvailable } = this.state;
    classNames(this.menu, { 'header__menu--available': menuAvailable });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/MenuHandler.js